import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { BASE_IMAGE_URL, PAGELENGTH } from 'src/app/endpoints';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { UserServiceService } from 'src/app/shared/service/userService/user-service.service';
import { DatePipe, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { UserDataService } from 'src/app/shared/service/userData/user-data.service';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { HasRoleDirective } from 'src/app/shared/directive/has-role.directive';
import { RouterLink } from '@angular/router';
declare var bootstrap: any;

@Component({
  selector: 'app-retailers',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    MatIcon,
    ReactiveFormsModule,
    DatePipe,
    NgSelectModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatLabel,
    MatInputModule,
    HasRoleDirective,
    FormsModule,
    RouterLink,
    NgClass
  ],
  templateUrl: './retailers.component.html',
  styleUrl: './retailers.component.scss'
})
export class RetailersComponent {

  formType: string = 'Add';
  retailerModal: any;
  sampleModal: any;
  startpoint: number;
  search: any;
  totalLoaded: number;
  total: any;
  pageNo: any;
  companyRes: any
  wholeSalerId: any
  _id: any
  states: any
  cities: any
  companyId: any


  constructor(
    private sampleService: SampleService,
    private companyService: CompanyService,
    private userService: UserServiceService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public userDataService: UserDataService,
  ) {
    this.setDisplayedColumns();
  }


  isCompanyLoggedIn: boolean = false

  getCompanyData() {
    let userData = this.userDataService.getData()
    let companyData = userData.company
    if (!!companyData) {
      this.isCompanyLoggedIn = true
      this.filter.companyId = companyData._id
      this.companyId = companyData._id
      this.getAllRetailers(null)
    }
    else {
      this.isCompanyLoggedIn = false
      this.getAllRetailers(null);
    }
  }


  ngOnInit(): void {
    this.getCompanyData()
    this.getCities()
    this.getStates()
    this.allCompaniesMini()
  }


  distributors: any[] = [];
  selectedDistributor: any;
  showRegisterForm: boolean = false;
  distributorSearchInput: boolean = false;

  searchDelayTimer: any = null;
  lastSearchTerm: string = '';



  searchText: string = '';


  onDistributorSearch(): void {
    const search = this.searchText?.trim();
    if (!search) {
      this.toastr.warning('Please enter a Retailer name.');
      return;
    }
    this.spinner.show();
    this.userService.distributorSearch({ search }).subscribe({
      next: (res) => {
        this.spinner.hide();
        this.distributors = res.success ? res.data : [];

        if (!this.distributors.length) {
          Swal.fire({
            title: 'Retailer Not Found',
            text: 'No match found. Add new?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Add Now',
            cancelButtonText: 'Cancel'
          }).then((result) => {
            if (result.isConfirmed) {
              this.distributorSearchInput = false;
              this.showRegisterForm = true;
            }
          });
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.toastr.error('Search failed.');
      }
    });
  }

  showForm() {
    this.distributorSearchInput = false
    this.distributors = []
    this.showRegisterForm = true
  }




  companyDistributorSearch(selected: any): void {
    this.spinner.show();
    const data = {
      distributorId: selected._id,
      companyId: this.companyId,
      distributorType: 2
    };

    this.userService.companyDistributorSearch(data).subscribe({
      next: (res) => {
        this.spinner.hide();

        if (res.data && res.data.length > 0) {
          Swal.fire({
            title: 'Already Linked',
            text: 'This Retailer is already linked with your company.',
            icon: 'success'
          });
        } else {
          Swal.fire({
            title: 'Retailer Not Linked',
            text: 'Do you want to link this Retailer to your company?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Add',
            cancelButtonText: 'Cancel'
          }).then((result) => {
            if (result.isConfirmed) {
              this.addDistributorToCompany(data);
            }
          });
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.toastr.error('Error checking link.');
      }
    });
  }



  addDistributorToCompany(data: any): void {
    this.userService.registerExistingDistributor(data).subscribe({
      next: (v: any) => {
        this.spinner.hide()
        if (v.success) {
          this.toastr.success(v.message, 'Success')
          this.hideModel()
          this.getAllRetailers(null)
        }
        else {
          this.spinner.hide()
          this.toastr.error(v.message, 'Error')
        }
      },
      error: (e: any) => {
        this.spinner.hide()
        this.toastr.error(e.message, 'Error')

      },
      complete: () => {
        this.spinner.hide()

      }
    })
  }


  getCities() {
    this.sampleService.getCities({}).subscribe({
      next: (result) => {
        if (result.success) {
          this.cities = result.data
        }
      },
      error: (e) => {
        this.toastr.error(e)
      }
    })
  }
  getStates() {
    this.sampleService.getStates({}).subscribe({
      next: (result) => {
        if (result.success) {
          this.states = result.data
        }
      },
      error: (e) => {
        this.toastr.error(e)
      }
    })
  }


  getImg(imgPath: any) {
    return BASE_IMAGE_URL + imgPath
  }


  displayedColumns: string[] = [];

  setDisplayedColumns(): void {
    this.displayedColumns = [
      'position', 'name', 'contact', 'cordinates', 'address', 'createdAt', 'isBlocked', 'samples',
    ];
    if (this.userDataService.roleMatch(['SAMPLE-ASSIGN'])) {
      this.displayedColumns.push('assign_sample');
    }
    if (this.userDataService.roleMatch(['RETAILER-EDIT'])) {
      this.displayedColumns.push('action');
    }
    if (this.userDataService.roleMatch(['SWITCH-DISTRIBUTOR-TYPE'])) {
      this.displayedColumns.push('switch');
    }

  }




  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('fileInput') fileInput: ElementRef;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    const retailerRegistermodalElement = document.getElementById('retailerModal');
    if (retailerRegistermodalElement) {
      this.retailerModal = new bootstrap.Modal(retailerRegistermodalElement);
    }
    const sampleModallElement = document.getElementById('sampleModal');
    if (sampleModallElement) {
      this.sampleModal = new bootstrap.Modal(sampleModallElement);
    }

  }


  dataSource = new MatTableDataSource<any>([]);


  debounceNameTimer: any = null;
  debounceCityStateTimer: any = null;

  filter: any = {
    name: '',
    cityState: '',
    companyId: null,
  };

  allCompanies: any[] = [];


  companyFilter(event: any): void {
    this.getAllRetailers(null);
  }


  allCompaniesMini() {
    this.companyService.allCompaniesMini({}).subscribe({
      next: (result) => {
        if (result.success) this.allCompanies = result.data;
      },
      error: (e) => this.toastr.error(e)
    });
  }



  onNameInputChange(event: any): void {
    clearTimeout(this.debounceNameTimer);
    this.debounceNameTimer = setTimeout(() => {
      const name = event.target.value.trim();
      this.filter.name = name || undefined;
      this.getAllRetailers(null);
    }, 500);
  }


  onCityStateChange(event: any): void {
    clearTimeout(this.debounceCityStateTimer);
    this.debounceCityStateTimer = setTimeout(() => {
      const cityState = event.target.value.trim();
      this.filter.cityState = cityState || undefined;
      this.getAllRetailers(null);
    }, 500);

  }

  pageSize: number = 10;
  getAllRetailers(event: any): void {
    this.spinner.show();

    // Reset on initial load or filter clear
    if (!event) {
      this.pageNo = 0;
      this.startpoint = 0;
      this.pageSize = this.pageSize || PAGELENGTH;
      this.dataSource.data = [];
      this.totalLoaded = 0;
    }

    // Handle page size change
    if (event?.pageSize && event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.pageNo = 0;
      this.startpoint = 0;
      this.dataSource.data = [];
      this.totalLoaded = 0;
    }

    // Handle page index change
    if (event?.pageIndex !== undefined) {
      this.pageNo = event.pageIndex;
      this.startpoint = this.pageNo * (this.pageSize || PAGELENGTH);
    }

    const data: any = {
      startpoint: this.startpoint,
      limit: this.pageSize || PAGELENGTH,
      distributorType: 2
    };

    if (this.search) data.search = this.search;
    if (this.filter?.name) data.nameEmail = this.filter.name;
    if (this.filter?.cityState) data.cityState = this.filter.cityState;
    if (this.filter?.companyId) data.companyId = this.filter.companyId;

    this.userService.allDistributor(data).subscribe({
      next: (result) => {
        this.spinner.hide();

        if (result.success) {
          this.companyRes = result;
          this.total = result.total ?? 0;
          this.dataSource.data = result.data || [];
          this.totalLoaded = this.dataSource.data.length;

          setTimeout(() => {
            if (this.paginator) {
              this.paginator.pageIndex = this.pageNo;
              this.paginator.length = this.total;
              this.paginator.pageSize = this.pageSize ?? PAGELENGTH;
            }
          }, 0);
        } else {
          this.toastr.error(result.message || 'Failed to load retailers');
        }
      },
      error: (e) => {
        this.spinner.hide();
        this.toastr.error(e?.message || 'Unexpected error');
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }


  registerForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^\d{10}$/)
    ]),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
    gstNo: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    state: new FormControl('', [Validators.required]),
    latitude: new FormControl(0.0),
    longitude: new FormControl(0.0)

  });



  openModel(type: any, wholeSalerId: any) {

    this.formType = type;
    if (this.formType == "Edit") {
      this.distributorSearchInput = false
      this.showRegisterForm = true
    }
    else {
      this.distributorSearchInput = true
      this.showRegisterForm = false
    }

    this.wholeSalerId = wholeSalerId
    if (wholeSalerId !== null) {
      this.userService.singleDistributor({ _id: wholeSalerId }).subscribe({
        next: (v: any) => {
          this.spinner.show()
          if (v.success) {
            this.registerForm.patchValue({
              name: v.data?.name,
              email: v.data?.email,
              password: v.data?.password,
              phone: v.data?.phone,
              gstNo: v.data?.gstNo,
              address: v.data?.address,
              city: v.data?.city,
              state: v.data?.state,
              latitude: v.data?.latitude,
              longitude: v.data?.longitude,

            })
          }
          else {
            console.log(v.message);
          }
        },
        error: (e: any) => {
          this.spinner.hide()

          this.toastr.error(e.message, 'Error')
        },
        complete: () => {
          this.spinner.hide()

        }
      })
    }
    this.retailerModal.show();
  }


  hideModel() {
    this.registerForm.reset();
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    this.showRegisterForm = false
    this.retailerModal.hide();
  }


  submit() {
    this.spinner.show()
    let data = new FormData()
    let distributorType = 2;
    data.append('distributorType', distributorType.toString());
    data.append('name', this.registerForm.value.name ?? ''),
      data.append('phone', this.registerForm.value.phone ?? null)
    data.append('email', this.registerForm.value.email ?? '')
    data.append('password', this.registerForm.value.password ?? '')
    data.append('gstNo', this.registerForm.value.gstNo ?? '')
    data.append('address', this.registerForm.value.address ?? '')
    data.append('city', this.registerForm.value.city ?? '')
    data.append('state', this.registerForm.value.state ?? '')
    data.append('latitude', this.registerForm.value.latitude?.toString() ?? "0.0");
    data.append('longitude', this.registerForm.value.longitude?.toString() ?? "0.0");
    if (this.formType === 'Add') {
      this.userService.registerDistributor(data).subscribe({
        next: (v: any) => {
          this.spinner.hide()
          if (v.success) {
            this.toastr.success(v.message, 'Success')
            this.hideModel()
            this.getAllRetailers(null)
          }
          else {
            this.spinner.hide()
            this.toastr.error(v.message, 'Error')
          }
        },
        error: (e: any) => {
          this.spinner.hide()
          this.toastr.error(e.message, 'Error')

        },
        complete: () => {
          this.spinner.hide()

        }
      })
    } else {
      data.append('_id', this.wholeSalerId ?? '')
      this.userService.updateDistributor(data).subscribe({
        next: (v: any) => {
          this.spinner.hide()
          if (v.success) {
            this.toastr.success(v.message, 'Success')
            this.hideModel()
            this.getAllRetailers(null)
          }
          else {
            this.spinner.hide()
            this.toastr.error(v.message, 'Error')
            this.hideModel()
          }
        },
        error: (e: any) => {
          this.spinner.hide()
          this.toastr.error(e.message, 'Error')
          this.hideModel()
        },
        complete: () => {
          this.spinner.hide()
          this.hideModel()
        }
      })
    }
  }


  wholeSalerStatus(element: any) {
    console.log(element);
    const currentStatus = element.isBlocked;
    const newStatus = !currentStatus;
    const action = newStatus ? 'Disable' : 'Enable';
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    });
    // text: `This will ${action.toLowerCase()} the Retailer.`,
    swalWithBootstrapButtons
      .fire({
        title: `${action}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `${action}`,
        cancelButtonText: 'Cancel',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.userService
            .enableDisableDistributor({ distributorId: element._id, isBlocked: newStatus, companyId: this.companyId })
            .subscribe({
              next: (v: any) => {
                if (v.success) {
                  element.isBlocked = newStatus;
                  this.toastr.success(`Retailer ${action.toLowerCase()} successfully.`);
                } else {
                  this.toastr.error(v.message, 'Error');
                }
              },
              error: (e: any) => {
                this.toastr.error(e.message, 'Error');
              },
            });
        }
      });
    return false;
  }


      switchDistributor(element: any) {
        Swal.fire({
          title: 'Switching...',
          text: 'Distributor is being switched!',
          toast: true,
          position: 'top-end',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true
        });

          const payload:any = {
            distributorId: element?.distributor?._id,
            companyId: element?.companyId
          }

          payload.role = 1;



          this.spinner.show();
          this.userService.changeDistributorType(payload).subscribe({
            next: (v: any) => {
              this.spinner.hide()
              if (v.success) {
                this.toastr.success(v.message, 'Success');
                this.getAllRetailers(null);
              }
              else {
                this.spinner.hide();
                Swal.fire({
                  icon: 'warning',
                  title: 'Switch not allowed',
                  text: v.message,
                  confirmButtonText: 'OK'
                });
              }
            },
            error: (e: any) => {
              this.spinner.hide()
              this.toastr.error(e.message, 'Error')

            },
            complete: () => {
              this.spinner.hide()
            }
        })
      }




}
